import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-async-debounce',
  slug: 'debounce',
  title: 'Debounce a search input',
  type: 'code',
  estSeconds: 600,
  contentVersion: 1,
});
